import { createContext, useCallback, useState, useContext } from 'react';

export const IXOneCaptureContext = createContext({});
export const IXOneModalContext = createContext({});

const mappingInitSelectedHierarchy = (productIds) => {
  // if (!productIds) return {};

  let result = {};

  for (const id of productIds) {
    result = {
      ...result,
      [id]: {
        selectedHierarchy: {},
      },
    };
  }

  return result;
};

export const IXOneProvider = ({ productIds, children }) => {
  return (
    <IXOneCaptureContextProvider productIds={productIds}>
      {children}
    </IXOneCaptureContextProvider>
  );
};

const IXOneCaptureContextProvider = ({ productIds, children }) => {
  const [selectedProductIds, setSelectProductIds] = useState(productIds);

  const [selectedHierarchies, setSelectedHierarchies] = useState(() =>
    mappingInitSelectedHierarchy(productIds)
  );

  const [ixoneGridApi, setIXOneGridApi] = useState(null);

  return (
    <IXOneCaptureContext.Provider
      value={{
        selectedHierarchies,
        ixoneGridApi,
        setIXOneGridApi,
        selectedProductIds,
        onSelectHierarchy: useCallback(({ productId, hierarchyValue }) => {
          setSelectedHierarchies((prevValues) => ({
            ...prevValues,
            [productId]: {
              selectedHierarchy: hierarchyValue,
            },
          }));
        }, []),
        onUpdateSelectedIds: useCallback(
          (id) => setSelectProductIds((prevValues) => prevValues.concat(id)),
          []
        ),
      }}
    >
      {children}
    </IXOneCaptureContext.Provider>
  );
};

export const useIXOneCapture = () => {
  const context = useContext(IXOneCaptureContext);

  if (context === undefined) {
    throw new Error(
      'useProductDetail must be used within a IXOneCaptureContext'
    );
  }

  return context;
};
